import React, { useState, useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import InputAdornment from "@mui/material/InputAdornment";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import AuthPageLayout, { LS, useAuthPageStyles } from "../../components/AuthPageLayout";

const Login = () => {
	const classes = useAuthPageStyles();
	const [user, setUser] = useState({ email: "", password: "" });
	const { handleLogin } = useContext(AuthContext);

	const handleChangeInput = e => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};

	const handlSubmit = e => {
		e.preventDefault();
		handleLogin(user);
	};

	return (
		<AuthPageLayout
			heroTitle="Central unificada de comunicação"
			heroSubtitle="Atenda seus clientes via Whatsapp Oficial, Whatsapp não oficial, Instagram e Facebook em um só lugar. Sistema integrado ao PABX IP LS e API Whatsapp Calling para Voz, tickets e campanhas em tempo real."
			formTitle={i18n.t("login.title")}
			formSubtitle="Acesse o Multi:"
			showNewClientContact
		>
			<form noValidate onSubmit={handlSubmit}>
				<TextField
					className={classes.textField}
					variant="outlined"
					margin="normal"
					required
					fullWidth
					id="email"
					label={i18n.t("login.form.email")}
					name="email"
					value={user.email}
					onChange={handleChangeInput}
					autoComplete="email"
					autoFocus
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<EmailOutlinedIcon />
							</InputAdornment>
						),
					}}
				/>
				<TextField
					className={classes.textField}
					variant="outlined"
					margin="normal"
					required
					fullWidth
					name="password"
					label={i18n.t("login.form.password")}
					type="password"
					id="password"
					value={user.password}
					onChange={handleChangeInput}
					autoComplete="current-password"
					InputProps={{
						startAdornment: (
							<InputAdornment position="start">
								<LockOutlinedIcon />
							</InputAdornment>
						),
					}}
				/>
				<Button type="submit" fullWidth className={classes.submit}>
					{i18n.t("login.buttons.submit")}
				</Button>
				<Typography align="center" variant="body2" style={{ color: LS.textMuted }}>
					<Link component={RouterLink} to="/signup" className={classes.authLink}>
						{i18n.t("login.buttons.register")}
					</Link>
				</Typography>
			</form>
		</AuthPageLayout>
	);
};

export default Login;
